import { OfferDiscountType } from "../constants/offers.constants";

export const calculatePriceWithDiscount = (
  price: number,
  discountValue: number,
  discountType: OfferDiscountType
): number => {
  if (discountValue <= 0) return price;
  if (discountType === OfferDiscountType.Percentage) {
    return Math.max(0, price - price * (discountValue / 100));
  }
  return Math.max(0, price - discountValue);
};

export const isValidDiscountValue = (
  discountValue: number,
  discountType: OfferDiscountType,
  productPrice: number
): boolean => {
  if (discountValue <= 0) return false;
  if (discountType === OfferDiscountType.Percentage) {
    return discountValue < 100;
  }
  return discountValue < productPrice;
};

export const getMinimumProductPrice = (prices: number[]): number | undefined => {
  if (!prices.length) return undefined;
  return Math.min(...prices);
};
